import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabbed-item',
  templateUrl: './tabbed-item.component.html',
  styleUrls: ['./tabbed-item.component.scss']
})
export class TabbedItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
